import React from 'react';
import { StyledResiliencyPolicyWrapper } from './styled';
import ResiliencyDashboard from '@components/precision/resiliency';
import ReleaseVersion from '@components/common/ReleaseVersion';
import { track } from '@utils';
import { NEW_RESILIENCY_DASHBOARD_PAGE_VIEWED } from '@utils/sensor/track';

const ResiliencyPage = () => {
  track({
    event: NEW_RESILIENCY_DASHBOARD_PAGE_VIEWED,
  });

  return (
    <StyledResiliencyPolicyWrapper>
      <ReleaseVersion type={'Alpha'} />
      <ResiliencyDashboard />
    </StyledResiliencyPolicyWrapper>
  );
};

export default ResiliencyPage;
